import { useEffect } from 'react';

type ToggleLayout = () => void;

const usePreviousLocation = (toggleLayout: ToggleLayout) => {
  useEffect(() => {
    const handlePopState = (event: PopStateEvent): void => {
      event.preventDefault();
      toggleLayout();
      window.history.pushState(null, '', window.location.href);
    };

    window.addEventListener('popstate', handlePopState);
    window.history.pushState(null, '', window.location.href);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [toggleLayout]);
};

export default usePreviousLocation;
